import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Brain, Heart, Users, Calendar, Ear } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function MechanismReveal() {
  const pillars = [{
    icon: Brain,
    label: 'ENTENDER',
    color: 'text-[#1B3A6B]',
    bg: 'bg-[#EEF2F7]',
    border: 'border-[#1B3A6B]/20',
    desc: 'El diagnóstico sin entrar en pánico'
  }, {
    icon: Users,
    label: 'ESTRUCTURAR',
    color: 'text-[#B83A52]',
    bg: 'bg-[#FDF0F3]',
    border: 'border-[#B83A52]/20',
    desc: 'Roles familiares sin conflictos'
  }, {
    icon: Ear,
    label: 'ESCUCHAR',
    color: 'text-[#1B3A6B]',
    bg: 'bg-[#EEF2F7]',
    border: 'border-[#1B3A6B]/20',
    desc: 'Con técnicas que realmente reconfortan'
  }, {
    icon: Calendar,
    label: 'EJECUTAR',
    color: 'text-[#4A4A6A]',
    bg: 'bg-[#F3F4F6]',
    border: 'border-[#E2E8F0]',
    desc: 'Un plan diario de cuidado sostenible'
  }, {
    icon: Heart,
    label: 'ESTAR',
    color: 'text-[#B83A52]',
    bg: 'bg-[#FDF0F3]',
    border: 'border-[#B83A52]/20',
    desc: 'Aprender a estar presente de verdad'
  }];
  return <section className="py-20 px-4 bg-[#EEF2F7] text-center relative overflow-hidden" data-id="element-185">
      <div className="max-w-[800px] mx-auto relative z-10" data-id="element-186">
        <div className="inline-block bg-[#1B3A6B] text-white font-bold px-4 py-1 rounded-full text-xs uppercase tracking-widest mb-6 shadow-sm" data-id="element-187">
          Presentando
        </div>

        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1C1C2E] mb-4" data-id="element-188">
          El Apoyo Incondicional
        </h2>

        <p className="text-[#4A4A6A] max-w-2xl mx-auto mb-12 text-lg" data-id="element-189">
          Guía paso a paso para que la familia se convierta en el mejor equipo
          de apoyo posible. Sin improvisar. Sin culpas.
        </p>

        {/* Product Showcase Card */}
        <div className="bg-white rounded-2xl shadow-navy-medium border border-[#E2E8F0] p-8 md:p-12 relative overflow-hidden mb-12" data-id="element-190">
          <div className="flex flex-col md:flex-row items-center gap-10 relative z-10" data-id="element-191">
            {/* Book Mockup */}
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-192">
              <div className="relative" data-id="element-193">
                {/* Animated glow */}
                <motion.div animate={{
                scale: [1, 1.2, 1],
                opacity: [0.3, 0.6, 0.3]
              }} transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute -inset-6 bg-gradient-to-b from-[#1B3A6B]/25 via-[#B83A52]/15 to-[#1B3A6B]/25 rounded-3xl blur-3xl" data-id="element-194" />
                <motion.img src="https://cdn.magicpatterns.com/uploads/b6mXwauyzTQX5WrXdT3wdS/1apoyo.png" alt="El Apoyo Incondicional — Guía Digital" initial={{
                y: 20,
                opacity: 0
              }} whileInView={{
                y: 0,
                opacity: 1
              }} animate={{
                y: [0, -10, 0]
              }} transition={{
                y: {
                  duration: 4,
                  repeat: Infinity,
                  ease: 'easeInOut'
                },
                opacity: {
                  duration: 0.8
                }
              }} className="relative w-[260px] h-auto drop-shadow-2xl" data-id="element-195" />
              </div>
            </div>

            {/* Product Details */}
            <div className="w-full md:w-1/2 text-left" data-id="element-196">
              <div className="flex items-center gap-1 mb-2" data-id="element-197">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-[#FCD34D] fill-[#FCD34D]" data-id="element-198" />)}
                <span className="text-xs text-[#8B8BAA] ml-2 font-medium" data-id="element-199">
                  Recomendado por Psicooncólogos
                </span>
              </div>

              <h3 className="text-2xl font-serif font-bold text-[#1C1C2E] mb-2" data-id="element-200">
                EL APOYO INCONDICIONAL
              </h3>
              <p className="text-[#4A4A6A] text-sm mb-6 pb-6 border-b border-[#E2E8F0]" data-id="element-201">
                Una guía de acción familiar.
                <br data-id="element-202" />
                <span className="text-[#1B3A6B] font-medium" data-id="element-203">
                  Escrita en lenguaje humano. Sin tecnicismos.
                </span>
              </p>

              <ul className="space-y-3 mb-8" data-id="element-204">
                {['Qué decir (y qué NO decir) al paciente', 'Cómo organizar roles sin peleas', 'Protocolos de autocuidado para el cuidador', 'Cómo hablar con niños y adolescentes'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#1C1C2E] text-sm font-medium" data-id="element-205">
                    <Check className="w-5 h-5 text-[#1B3A6B] shrink-0" data-id="element-206" />
                    {item}
                  </li>)}
              </ul>

              <div className="flex items-center gap-4" data-id="element-207">
                <div className="text-center" data-id="element-208">
                  <span className="text-xs text-[#8B8BAA] line-through block" data-id="element-209">
                    VALOR: $37
                  </span>
                  <span className="text-3xl font-bold text-[#B83A52]" data-id="element-210">
                    HOY: $7.77
                  </span>
                </div>
                <a href="https://nutrikaia.com/cart/46420389494974:1" onClick={() => trackAddToCart()} className="relative overflow-hidden inline-flex items-center gap-2 bg-[#1B3A6B] hover:bg-[#2D4F85] text-white px-6 py-3 rounded-lg font-bold text-sm uppercase tracking-wide transition-colors shadow-lg" data-id="element-211">
                  <motion.span animate={{
                  x: ['-100%', '200%']
                }} transition={{
                  duration: 2.5,
                  repeat: Infinity,
                  ease: 'linear',
                  repeatDelay: 1.5
                }} className="absolute inset-0 w-1/3 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-20deg] pointer-events-none" data-id="element-212" />
                  <span className="relative z-10 flex items-center gap-1.5" data-id="element-213">
                    Descargar Ahora
                    <motion.span animate={{
                    x: [0, 4, 0]
                  }} transition={{
                    duration: 0.8,
                    repeat: Infinity,
                    ease: 'easeInOut'
                  }} data-id="element-214">
                      →
                    </motion.span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Protocol 5E */}
        <div className="text-center mb-8" data-id="element-215">
          <p className="text-xs font-bold uppercase tracking-widest text-[#B83A52] mb-2" data-id="element-216">
            El Método
          </p>
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#1C1C2E] mb-2" data-id="element-217">
            El Protocolo 5E
          </h3>
          <p className="text-[#4A4A6A] max-w-xl mx-auto text-sm" data-id="element-218">
            Las familias que sostienen a un paciente no lo hacen con más
            sentimiento. Lo hacen con estructura.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8" data-id="element-219">
          {pillars.map((pillar, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`${pillar.bg} border ${pillar.border} rounded-xl p-4 text-center`} data-id="element-220">
              <div className={`inline-flex items-center justify-center p-2 rounded-full bg-white mb-3 shadow-sm ${pillar.color}`} data-id="element-221">
                <pillar.icon className="w-5 h-5" data-id="element-222" />
              </div>
              <p className={`font-bold text-sm uppercase tracking-wider mb-2 ${pillar.color}`} data-id="element-223">
                {pillar.label}
              </p>
              <p className="text-xs text-[#4A4A6A] leading-tight" data-id="element-224">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}